export const faqs = [
  {
    question: '抖ying和抖音有什么区别？',
    answer: '抖ying是抖音国际版的名称（TikTok在中国以外地区的称呼演变），而抖音是中国国内版本。两者在核心功能上相似，但运营团队、内容生态和算法机制有所差异。国内用户使用抖音App，海外用户使用TikTok。本文中"抖ying"泛指抖音/TikTok短视频平台生态。',
  },
  {
    question: '新手如何快速在抖ying上获得第一批粉丝？',
    answer: '快速涨粉需要做到以下几点：1）完善个人资料，设置吸引人的头像和简介；2）前5条视频决定账号调性，务必精心制作；3）选择垂直领域深耕，避免内容杂乱；4）利用热门话题和挑战赛蹭流量；5）保持每天至少1-2条高质量更新；6）积极回复评论，增强粉丝粘性。通常坚持1-3个月可见明显效果。',
  },
  {
    question: '抖ying的推荐算法是如何工作的？',
    answer: '抖ying采用多级流量池推荐机制。新视频发布后会先进入200-500人的初始流量池，根据完播率、点赞率、评论率、转发率等指标决定是否进入更大流量池（1k-5k-1w-10w-100w）。核心指标排序：完播率 &gt; 点赞率 &gt; 评论率 &gt; 转发率。视频标签、发布时间、账号权重也会影响推荐效果。',
  },
  {
    question: '在抖ying上做直播带货需要什么条件？',
    answer: '直播带货基本条件：1）账号粉丝达到1000及以上可开通商品橱窗；2）完成实名认证；3）缴纳保证金（通常500-2000元不等）；4）准备好稳定的网络和直播设备；5）选品需要注重性价比和受众匹配度。建议先通过短视频积累粉丝信任，再开启直播带货，转化率会更高。',
  },
  {
    question: '企业号和个人号有什么区别？',
    answer: '企业号（蓝V认证）相比个人号有以下优势：1）品牌官方认证标识，增加信任感；2）可使用官网链接、联系电话等营销组件；3）享有私信自动回复、用户标签管理等高级功能；4）可投放信息流广告和DOU+；5）不受部分营销内容限制。认证费用通常600元/年，建议品牌商家尽早认证。',
  },
  {
    question: '抖ying运营中常见的违规行为有哪些？',
    answer: '常见违规包括：1）搬运他人原创内容（会被限流或封号）；2）发布低俗、虚假、违法信息；3）恶意刷量（买粉、买赞）；4）过度营销引流（诱导关注、站外导流）；5）评论区批量广告。建议仔细阅读社区自律公约，避免触碰平台红线。一旦被限流，恢复通常需要1-4周时间。',
  },
  {
    question: '如何提高视频的完播率？',
    answer: '提升完播率的核心技巧：1）前3秒必须抓住注意力，用悬念、冲突或视觉冲击开场；2）控制视频时长在15-30秒为佳（新手不宜过长）；3）采用"黄金7秒"法则——每7秒设置一个信息爆点或转折；4）结尾设置互动引导（评论区提问）；5）画面节奏紧凑，避免拖沓；6）背景音乐选择与内容情绪匹配的热门BGM。',
  },
];